import { observer } from "mobx-react";
import * as React from "react";
import { type HelpArticle } from "../../help-types";
import { store } from "../../store";
import css from "./help-article-preview.scss";

export interface HelpArticlePreviewProps {
    readonly article: HelpArticle;
}

@observer
export class HelpArticlePreview extends React.Component<HelpArticlePreviewProps> {
    public render(): JSX.Element {
        const { title, summary } = this.props.article;
        return (
            <div
                className={css.helpArticlePreview}
                onClick={() => store.serviceHelp.enterArticle(this.props.article.filename)}
            >
                <h3 className={css.helpArticlePreview__title}>{store.i18n.t(title)}</h3>
                <p className={css.helpArticlePreview__summary}>
                    <span>{store.i18n.t(summary)}</span>{" "}
                    <a className={css.helpArticlePreview__readMore}>
                        {store.i18n.t("helpArticlePreview.readMore")}
                    </a>
                </p>
            </div>
        );
    }
}
